<ul
  class="container account-details-nav d-flex align-items-center justify-content-start gap-3 mb-4"
  [ngClass]="{ 'corporate-nav': isCorporate }"
  *notInPopulation="[populations.JuniorBluebirds]"
>
  <li class="nav-item" [routerLink]="['/account']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
    <label class="mb-0 fw-bold">{{ 'account.nav.profile' | translate }}</label>
  </li>
  <li class="nav-item" [routerLink]="['/activity']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
    <label class="mb-0 fw-bold">{{ 'account.nav.activity' | translate }}</label>
  </li>
</ul>
